import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=1c78ff02"
import script from "./BalanceCard.vue?vue&type=script&lang=ts"
export * from "./BalanceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports